<section *ngIf="formation">
    <app-header [title]="formation.title" [backLinkText]="'cacademy.go_back' | translate" (onBackLinkClick)="goBack()"></app-header>

    <div class="p-4 md:p-6 lg:p-8 flex flex-col gap-8">
        <p class="typography-body-l-medium textSecondary-color m-0">{{formation.description}}</p>
        <div class="bg-white">
            <iframe *ngIf="sanitizedFormationLink" class="w-full h-[700px]" [src]="sanitizedFormationLink"></iframe>
            <div class="p-6">
                <div class="flex flex-wrap justify-between gap-3">
                    <div class="flex-1 basis-full md:basis-0">
                        <div class="flex flex-1 flex-wrap gap-6">
                            <span class="typography-body-m-light">{{formation.publicationDate | date: 'mediumDate' }}</span>
                            <div class="flex gap-1 align-middle">
                                <img class="w-4 h-4" src="assets/icons/date.svg" alt="Date Icon">
                                <span class="typography-body-m-light">{{'minutes' | translate: {varMinutes: 20} }}</span>
                            </div>
                            <app-stars-rating [rating]="formation.rating"></app-stars-rating>
                        </div>
                    </div>
                    <div class="flex-1 basis-full md:basis-0">
                        <div class="flex flex-wrap gap-1 justify-start md:justify-end">
                            <div class="px-2 py-1 bg-background-ultralight-00">
                                <span class="typography-body-m-regular text-semantic-info">{{(formation.application ? 'cacademy.application.' + formation.application : '') | translate}}</span>
                            </div>
                            <div *ngFor="let brand of formation.brands" class="px-2 py-1 bg-background-ultralight-00">
                                <img *ngIf="brand" class="textSecondary" [src]="getBrandIconSrc(brand)" [alt]="brand">
                            </div>
                        </div>
                    </div>

                </div>
                <div class="mt-6">
                    <div *ngIf="formation.completedAt" class="flex items-center gap-1">
                        <div class="rounded-full bg-semantic-success w-[10px] h-[10px]"></div>
                        <span class="typography-body-m-regular text-semantic-success">{{'cacademy.completed_on' | translate: {varDate: (formation.completedAt | date: 'mediumDate' )} }}</span>
                    </div>

                    <div *ngIf="!formation.completedAt" class="flex flex-col gap-4 bg-background-dark-01 p-6 lg:flex-row lg:items-center lg:justify-between">
                        <div class="flex flex-col gap-4">
                            <p class="typography-title-m text-white m-0">{{'cacademy.finish_and_rate_title' | translate}}</p>
                            <p class="typography-body-m-regular text-white m-0">{{'cacademy.finish_and_rate_description' | translate}}</p>
                        </div>
                        <div class="flex">
                            <div class="basis-full lg:basis-0">
                                <app-button size="medium" [block]="true" [textWrap]=false (onClick)="isConfirmFormationCompletedModalOpen = true">{{'cacademy.i_finished_the_formation' | translate}}</app-button>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
        <ng-container *ngIf="formation.relatedDocuments && formation.relatedDocuments.length > 0">
            <div class="divider"></div>
            <div class="bg-white p-6 flex flex-col gap-6">
                <h2 class="typography-title-m m-0">{{'cacademy.related_documents' | translate}}</h2>
                <div *ngFor="let relatedDocument of formation.relatedDocuments" class="flex items-center gap-3">
                    <img src="assets/icons/document2.svg" alt="Document">
                    <span class="typography-body-m-regular">{{relatedDocument.name}}</span>
                    <img src="assets/icons/download.svg" alt="Download" class="cursor-pointer" (click)="downloadRelatedDocument(relatedDocument)">
                </div>
            </div>
        </ng-container>
        <ng-container *ngIf="relatedFormations && relatedFormations.length > 0">
            <div class="divider"></div>
            <div>
                <app-c-academy-list
                    [formations]="relatedFormations"
                    [title]="'cacademy.related_formations' | translate"
                ></app-c-academy-list>

            </div>
        </ng-container>
    </div>
</section>

<app-confirm-modal
    [isOpen]="isConfirmFormationCompletedModalOpen"
    [confirmText]="'cacademy.i_finished_the_formation' | translate"
    [cancelText]="'cacademy.i_have_not-finished_the_formation_yet' | translate"
    [title]="'cacademy.confirm_that_you_finished_the_formation' | translate"
    [buttonsInRow]="true"
    (onConfirm)="updateFormationAsCompleted()"
    (onCancel)="cancelFormationCompletion()"
></app-confirm-modal>

<app-confirm-modal
    [isOpen]="isRateFormationModalOpen"
    [confirmText]="'cacademy.submit_rating' | translate"
    [cancelText]="''"
    (onCancel)="isRateFormationModalOpen = false"
    (onClose)="isRateFormationModalOpen = false"
    (onConfirm)="submitRating()"
>
    <div class="flex flex-col gap-4 items-center">
        <p class="typography-title-m m-0">{{'cacademy.rate_formation_title' | translate}}</p>
        <p class="typography-body-l-regular text-text-secondary m-0">{{'cacademy.rate_formation_description' | translate}}</p>
        <div>
            <app-stars-rating
                [isInteractive]="true"
                (selectedRatingChange)="selectedRating = $event"
            ></app-stars-rating>
        </div>
    </div>
</app-confirm-modal>
